import React from 'react';
import { Link } from 'react-router-dom';
import './InitialScreen.css';

function InitialScreen() {
  return (
    <section className='all-section'>
      <div className="initial-screen">
        <h1 className="title2">Projeto Águas: Conheça seu Rio</h1>

        {/* Use o Link para redirecionar para a página de login */}
        <Link to="/question-list" className='btnStart'>
          Iniciar novo quiz
        </Link>
      </div>
    </section>
  );
}

export default InitialScreen;
